<template>
  <div :class="[$style.base, {[$style.smallScreen]: $screen === 's'}]">
    <div :class="$style.rowTop">
      <BaseInput
        v-model="address.street"
        :label="$t('global.street')"
        required
        v-test="'fiskaly-street'"
      />
      <BaseInput
        v-model="address.number"
        :label="$t('global.street_number')"
        required
        v-test="'fiskaly-street-number'"
      />
    </div>
    <div :class="$style.rowBottom">
      <BaseInput
        v-model="address.postalCode"
        :label="$t('global.postal_code')"
        required
        v-test="'fiskaly-postal-code'"
      />
      <BaseInput
        v-model="address.city"
        :label="$t('global.city')"
        required
        v-test="'fiskaly-city'"
      />
      <BaseInput
        :modelValue="countryName"
        :label="$t('global.country')"
        disabled
        v-test="'fiskaly-country'"
      />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useCompanyStore } from '@/stores/company';
import { useLocalizationStore } from '@/stores/localization';

type Address = {
  street: string;
  number: string;
  postalCode: string;
  city: string;
};

const address = defineModel<Address>({ required: true });

const countryName = computed(() => {
  const { language } = useLocalizationStore();
  const { company } = useCompanyStore();
  const regionNames = new Intl.DisplayNames([language], {
    type: 'region',
  });
  return regionNames.of(company.country.toUpperCase());
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}

.rowTop, .rowBottom {
  display: flex;
  gap: $spacing;

  .base.smallScreen & {
    flex-direction: column;
  }
}

.rowTop {
  & > * {
    &:first-child {
      flex: 4;
    }
    &:last-child {
      flex: 1;
    }
  }
}

.rowBottom {
  & > * {
    flex: 1;
  }
}
</style>
